import { render, staticRenderFns } from "./schedule-delegation.vue?vue&type=template&id=4ba460fc&lang=pug&"
import script from "./schedule-delegation.vue?vue&type=script&lang=js&"
export * from "./schedule-delegation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports